/* Funny Christmas Jumpers behaviour layer. ES5 on purpose (Shopify only auto-minifies ES5-valid scripts). Dependency-free.
   Rules: never hide content, every effect has a reduced-motion exit, nothing listens to window scroll (IntersectionObserver only),
   every init is idempotent and re-runs on shopify:section:load. Design reference: DESIGN.md. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var SIZES = ['S', 'M', 'L', 'XL', 'XXL', 'XXXL'];
  var ua = navigator.userAgent || '';
  var inApp = /\b(FBAN|FBAV|FB_IAB|FBIOS|Instagram|musical_ly|Bytedance|BytedanceWebview|trill|TikTok)(?:\b|_)/i.test(ua) || (/\bAndroid\b/i.test(ua) && /;\s?wv\)/i.test(ua));

  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function readData(scope) { var el = $('[data-tc-data]', scope); if (!el) return null; try { return JSON.parse(el.textContent); } catch (e) { return null; } }
  function findVariant(prod, style, size) {
    if (!prod) return null;
    for (var i = 0; i < prod.variants.length; i++) {
      var v = prod.variants[i];
      if (v.style === style && (size == null || String(v.size).toLowerCase() === String(size).toLowerCase())) return v;
    }
    return null;
  }
  function meter(n) { var h = ''; for (var i = 0; i < 5; i++) h += '<i' + (i < n ? ' class="on"' : '') + '></i>'; return h; }

  /* ---------- the room's physical events ---------- */
  var lastFlash = 0;
  function flash() {
    if (reduce) return;
    var now = Date.now(); if (now - lastFlash < 400) return; lastFlash = now;   /* WCAG 2.3.1: at most 3 per second */
    var f = $('[data-tc-flash]'); if (!f) return;
    f.classList.remove('is-on'); void f.offsetWidth; f.classList.add('is-on');
  }
  function stampOn(el) {
    if (!el) return; el.classList.remove('is-on'); void el.offsetWidth; el.classList.add('is-on');
    clearTimeout(el._t); el._t = setTimeout(function () { el.classList.remove('is-on'); el.style.opacity = '0'; }, 2600);
    el.style.opacity = '';
  }
  function blink(el) { if (!el || reduce) return; el.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(-6px)' }, { transform: 'translateX(6px)' }, { transform: 'translateX(0)' }], { duration: 260 }); }

  /* ---------- cart ---------- */
  function refreshCart(silent) {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      $$('[data-tc-checkout]').forEach(function (a) { a.hidden = !(c.item_count > 0); });
      $$('[data-tc-cartn]').forEach(function (n) {
        n.textContent = c.item_count; if (!silent) { n.classList.remove('is-pop'); void n.offsetWidth; n.classList.add('is-pop'); }
        if (n.parentNode) n.parentNode.setAttribute('aria-label', 'Bag, ' + c.item_count + ' items');
      });
    }).catch(function () {});
  }
  function addToCart(id) {
    return fetch(root + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    }).then(function (r) { if (!r.ok) { var e = new Error('add failed'); e.status = r.status; throw e; } return r.json(); })
      .then(function (j) { return refreshCart().then(function () { return j; }); });
  }
  function failText(e) { return (e && e.status === 422) ? 'Not available right now.' : "Couldn't add that. Try again."; }
  function setLabel(btn, text, ms) {
    var span = btn.querySelector('span') || btn; var old = btn.getAttribute('data-old') || span.textContent;
    btn.setAttribute('data-old', old); span.textContent = text;
    clearTimeout(btn._t); btn._t = setTimeout(function () { span.textContent = btn.getAttribute('data-old'); btn.removeAttribute('data-old'); }, ms || 1500);
  }
  function share(text, url, btn) {
    var done = function () { if (btn) { var o = btn.textContent; btn.textContent = 'Copied'; setTimeout(function () { btn.textContent = o; }, 1600); } };
    if (navigator.share) { navigator.share({ title: document.title, text: text, url: url }).catch(function () {}); return; }
    var all = text + ' ' + url;
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(all).then(done, function () {});
  }
  function shareText(name, st) { var who = (name || '').replace(/^\s+|\s+$/g, ''); return (who ? who + ', ' : '') + "you're No. " + st.no + ', ' + st.name + '. Step forward.'; }

  /* ---------- stage (home hero) ---------- */
  function initStage(sec) {
    var data = readData(sec); if (!data) return;
    var styles = {}; data.styles.forEach(function (s) { styles[s.no] = s; });
    var room = $('[data-tc-suspects]', sec), sheet = $('[data-tc-sheet]', sec), sheetIn = $('[data-tc-sheetin]', sec), live = $('[data-tc-live]', sec);
    var sel = null, size = null;
    var roomEl = $('[data-tc-room]', sec), measure = $('[data-tc-measure]', sec), mlabel = $('[data-tc-measure-l]', sec), chartEl = $('.tc-chart', sec);
    /* the measuring line: reads a height off the chart for the top of the figure you picked */
    function measureTo(no) {
      if (!measure || !roomEl || !chartEl) return;
      var fig = $('.tc-suspect-li[data-no="' + no + '"] .tc-fig img', room); if (!fig) return;
      var rr = roomEl.getBoundingClientRect(), fr = fig.getBoundingClientRect(), ch = chartEl.getBoundingClientRect().height;
      var y = Math.max(0, Math.min(ch, fr.top - rr.top));
      var ft = 6.5 - (y / ch) * 1.5, whole = Math.floor(ft), inch = Math.round((ft - whole) * 12); if (inch === 12) { whole += 1; inch = 0; }
      measure.style.transform = 'translateY(' + y.toFixed(1) + 'px)'; mlabel.textContent = whole + "'" + inch + '"';
      measure.classList.add('is-on');
    }
    /* typed entries: the sheet's lines are typed out left to right (clip only; the text is already in the DOM) */
    function typeIn(scope) {
      if (!scope.animate) return;
      var dd = $('.tc-sheetdl .tc-field:first-child dd', scope); if (!dd) return;   /* only the charge is typed; the verdicts are the payoff and read at once */
      var n = Math.min(dd.textContent.length, 90);
      dd.animate([{ clipPath: 'inset(0 100% 0 0)' }, { clipPath: 'inset(0 0 0 0)' }], { duration: Math.min(360, 120 + n * 5), delay: 220, easing: 'steps(' + Math.max(6, Math.round(n / 2)) + ', end)', fill: 'backwards' });
    }
    /* interrogation lamp: only where there is a real hover pointer */
    if (roomEl && window.matchMedia && matchMedia('(hover:hover) and (pointer:fine)').matches && !reduce) {
      var lamp = document.createElement('div'); lamp.className = 'tc-lamp'; lamp.setAttribute('aria-hidden', 'true'); roomEl.appendChild(lamp); roomEl.classList.add('has-lamp');
      var lx = 0, ly = 0, tx = 0, ty = 0, raf = 0;
      var frame = function () { lx += (tx - lx) * 0.22; ly += (ty - ly) * 0.22; lamp.style.transform = 'translate3d(' + lx.toFixed(1) + 'px,' + ly.toFixed(1) + 'px,0)'; raf = (Math.abs(tx - lx) + Math.abs(ty - ly) > 0.5) ? requestAnimationFrame(frame) : 0; };
      roomEl.addEventListener('pointermove', function (e) { if (e.pointerType === 'touch') return; var r = roomEl.getBoundingClientRect(); tx = e.clientX - r.left; ty = e.clientY - r.top; if (!roomEl.classList.contains('is-lit')) { lx = tx; ly = ty; roomEl.classList.add('is-lit'); } if (!raf) raf = requestAnimationFrame(frame); }, { passive: true });
      roomEl.addEventListener('pointerleave', function () { roomEl.classList.remove('is-lit'); });
    }

    function sheetHTML(no) {
      var s = styles[no]; var v = findVariant(data.product, no, size) || findVariant(data.product, no, null);
      var sizes = SIZES.map(function (z) { return '<button class="tc-box" type="button" data-size="' + z + '" aria-pressed="' + (z === size) + '">' + z + '</button>'; }).join('');
      var full = (data.product && data.styles.length > 7) ? '<a class="tc-link tc-linkbtn" href="' + esc(data.product.url) + '?variant=' + ((findVariant(data.product, no, null) || {}).id || '') + '" data-tc-vt-src="' + no + '">Full page</a>' : '';
      var sgl = '<a class="tc-link" href="' + root + 'pages/size-guide#find-size">Find your size</a>';
      return '<div class="tc-sheet-grid">' +
        '<div class="tc-sheet-buyp">' +
        '<h2 class="tc-sheet-title" tabindex="-1">No. ' + s.no + ' ' + esc(s.name) + '</h2>' +
        '<p class="tc-sheet-priceline"><b>' + esc(v ? v.price : '$44.99') + '</b><span>Printed crewneck sweatshirt, not a knit. $5 flat shipping, customs fees may apply. Typically 2 to 3 weeks.</span></p>' +
        '<div class="tc-sheet-sizel"><span id="tc-ss-l">Size</span>' + sgl + '</div>' +
        '<div class="tc-sizes" role="group" aria-labelledby="tc-ss-l">' + sizes + '</div>' +
        '<p class="tc-sheet-err" data-tc-err role="alert" hidden>Pick a size first.</p>' +
        '<div class="tc-sheet-buy"><span class="tc-stamp" aria-hidden="true">Booked</span>' +
        '<button class="tc-btn tc-btn--tape tc-btn--wide" type="button" data-tc-buynow><span>Buy now</span></button>' +
        '<button class="tc-btn tc-btn--ghost tc-btn--wide" type="button" data-tc-add><span>Add to bag</span></button>' +
        '<button type="button" class="tc-link tc-linkbtn tc-sheet-try" data-tc-book data-no="' + s.no + '">' + '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" focusable="false"><path d="M4 8h3l2-3h6l2 3h3v11H4z" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/><circle cx="12" cy="13" r="3.5" fill="none" stroke="currentColor" stroke-width="2"/></svg>' + '<span>Try it on yourself</span></button></div>' +
        '<div class="tc-sheet-bagrow" data-tc-checkout hidden><span>In your bag.</span><a class="tc-btn tc-btn--wide" href="' + root + 'checkout">Check out</a></div>' +
        '<p class="tc-sheet-trust">Misprinted or damaged? We remake it or refund you. UK and EU buyers keep their 14-day right to cancel; elsewhere, printed to order means no change-of-mind returns. Duties and taxes aren\'t included. <a href="' + root + 'pages/shipping-and-returns">Details</a></p>' +
        '</div>' +
        '<figure class="tc-sheet-photo"><img src="' + esc(s.photo) + '" alt="' + esc(s.photoalt) + '" width="720" height="960"><figcaption>Exhibit ' + esc(s.exhibit) + '.</figcaption></figure>' +
        '<div class="tc-sheet-info">' +
        '<p class="tc-fine tc-sayshead">What people will say. Jokes, not reviews.</p>' +
        '<dl class="tc-sheetdl">' +
        '<div class="tc-field"><dt>Charge</dt><dd>' + esc(s.charge) + '</dd></div>' +
        '<div class="tc-field"><dt>Loudness</dt><dd><span class="tc-meter" aria-hidden="true">' + meter(s.loud) + '</span>' + s.loud + ' of 5. ' + esc(s.loudlabel) + '</dd></div>' +
        '<div class="tc-field"><dt>Grandma says</dt><dd>' + esc(s.g) + '</dd></div>' +
        '<div class="tc-field"><dt>Boss says</dt><dd>' + esc(s.b) + '</dd></div>' +
        '<div class="tc-field"><dt>HR says</dt><dd>' + esc(s.h) + '</dd></div>' +
        '<div class="tc-field"><dt>Santa says</dt><dd>' + esc(s.santa) + '</dd></div></dl>' +
        '<div class="tc-sheet-links">' + full + '<button type="button" class="tc-link tc-linkbtn" data-tc-sharetoggle aria-expanded="false">Send this one to a mate</button></div>' +
        '<div class="tc-share"><label class="tc-sr" for="tc-for-' + s.no + '">Who is this for?</label><input class="tc-input" id="tc-for-' + s.no + '" type="text" placeholder="Who is this for?" autocomplete="off" data-tc-for><button class="tc-btn" type="button" data-tc-share>Copy the message</button></div>' +
        '</div></div>';
    }
    function step(no, opts) {
      opts = opts || {};
      if (!styles[no]) return;
      var still = reduce || !!opts.instant;
      if (sel === no && !opts.force) { unstep(); return; }
      var first = sel === null;
      sel = no; if (roomEl) roomEl.classList.toggle('is-still', still);
      $$('.tc-suspect', room).forEach(function (b) {
        var on = +b.getAttribute('data-no') === no; b.setAttribute('aria-pressed', on ? 'true' : 'false'); b.classList.toggle('is-front', on);
      });
      if (!still) flash();
      sheetIn.innerHTML = sheetHTML(no);
      sheet.hidden = false; sheet.classList.remove('is-open', 'is-instant'); void sheet.offsetWidth; sheet.classList.add('is-open'); if (still) sheet.classList.add('is-instant');
      measureTo(no); if (!still) typeIn(sheetIn);
      var hd = $('.tc-sheet-title', sheetIn);
      if (hd) setTimeout(function () { try { hd.focus({ preventScroll: true }); } catch (e) {} }, 320);
      if (!opts.noscroll || first) {
        setTimeout(function () { sheet.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' }); }, still ? 0 : 280);   /* flash, rise and measuring line play on screen first, then the page moves */
      }
    }
    function unstep() {
      var back = sel && $('.tc-suspect[data-no="' + sel + '"]', room), hadFocus = sheet.contains(document.activeElement);
      sel = null; if (measure) measure.classList.remove('is-on');
      $$('.tc-suspect', room).forEach(function (b) { b.setAttribute('aria-pressed', 'false'); b.classList.remove('is-front'); });
      sheet.hidden = true;
      if (back && hadFocus) { try { back.focus({ preventScroll: true }); } catch (e) {} }   /* focus must not fall to the body when the sheet closes */
    }
    sec.__tcStep = step;
    sec.addEventListener('click', function (e) {
      var b = e.target.closest('.tc-suspect');
      if (b && room.contains(b)) { step(+b.getAttribute('data-no'), { instant: e.detail === 0 }); return; }
      var z = e.target.closest('.tc-box[data-size]');
      if (z && sheetIn.contains(z)) {
        size = z.getAttribute('data-size');
        $$('.tc-box[data-size]', sheetIn).forEach(function (c) { c.setAttribute('aria-pressed', c === z ? 'true' : 'false'); });
        var se = $('[data-tc-err]', sheetIn); if (se) se.hidden = true;
        return;
      }
      var add = e.target.closest('[data-tc-add],[data-tc-buynow]');
      if (add && sel) {
        var goNow = add.hasAttribute('data-tc-buynow');
        if (!size) {
          var se2 = $('[data-tc-err]', sheetIn); if (se2) se2.hidden = false;
          blink($('.tc-sizes', sheetIn)); if (live) { live.textContent = ''; setTimeout(function () { live.textContent = 'Pick a size first.'; }, 30); }
          return;
        }
        var v = findVariant(data.product, sel, size);
        if (!v) { setLabel(add, 'Not offered in that size', 2000); return; }
        if (!v.available) { setLabel(add, 'Not available right now', 3000); if (live) live.textContent = 'Not available right now.'; return; }
        if (add.getAttribute('aria-disabled') === 'true') return;
        add.setAttribute('aria-disabled', 'true'); setLabel(add, goNow ? 'One moment...' : 'Booking...', 6000);   /* aria-disabled keeps keyboard focus on the button */
        addToCart(v.id).then(function () {
          if (goNow) { location.assign(root + 'checkout'); return; }   /* Buy now: add this one, straight to checkout */
          add.removeAttribute('aria-disabled'); stampOn($('.tc-stamp', sheetIn)); setLabel(add, 'In the bag', 1800);
          if (live) live.textContent = 'In the bag.';
        }).catch(function (er) { add.removeAttribute('aria-disabled'); setLabel(add, failText(er), 3000); if (live) live.textContent = failText(er); });
        return;
      }
      var t = e.target.closest('[data-tc-sharetoggle]');
      if (t) { var sh = $('.tc-share', sheetIn); var open = sh.classList.toggle('is-open'); t.setAttribute('aria-expanded', open ? 'true' : 'false'); return; }
      var sb = e.target.closest('[data-tc-share]');
      if (sb && sel) { var who = $('[data-tc-for]', sheetIn).value; share(shareText(who, styles[sel]), location.origin + location.pathname + '#lineup-' + sel, sb); }
    });
    $$('[data-hr]', sec).forEach(function (b) {
      b.addEventListener('click', function () {
        var no = +b.getAttribute('data-hr');
        if (history.replaceState) history.replaceState(null, '', '#lineup-' + no);
        step(no, { force: true });
      });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && sel && !document.querySelector('dialog.tc-bk[open]')) unstep(); });
    function fromHash() { var m = (location.hash || '').match(/^#lineup-(\d)$/); if (m) step(+m[1], { force: true }); }
    window.addEventListener('hashchange', fromHash);
    fromHash();
  }

  /* exhibits: tapping a snapshot steps that suspect forward in the stage */
  function bindExhibits() {
    if (document.documentElement.hasAttribute('data-tc-exh')) return;
    document.documentElement.setAttribute('data-tc-exh', '');
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-tc-exhibit]'); if (!a) return;
      var stage = $('[data-tc-stage]'); if (!stage || !stage.__tcStep) return;
      e.preventDefault();
      var no = +a.getAttribute('data-tc-exhibit');
      if (history.replaceState) history.replaceState(null, '', '#lineup-' + no);
      stage.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      setTimeout(function () { stage.__tcStep(no, { force: true, noscroll: false }); }, reduce ? 0 : 350);
    });
  }

  /* ---------- product page ---------- */
  function initPdp(sec) {
    var data = readData(sec); if (!data || !data.product) return;
    var styles = {}; data.styles.forEach(function (s) { styles[s.no] = s; });
    var cur = +sec.getAttribute('data-start-style') || 1, size = null;
    var q = function (n) { return $('[data-tc-' + n + ']', sec); };
    var el = { pbuy: q('pdpbuy'), img: q('img'), no: q('no'), name: q('name'), sub: q('sub'), price: q('price'), meter: q('meter'), loud: q('loud'), chips: q('chips'), sizes: q('sizes'), add: q('add'), addlbl: q('addlbl'), id: q('id'), live: q('live'), thumbs: q('thumbs'), charge: q('charge'), g: q('g'), b: q('b'), h: q('h'), santa: q('santa'), form: $('#tc-product-form', sec), sizehelp: q('sizehelp'), stamp: q('stamp'), cap: q('cap'), checkout: q('checkout') };
    var sticky = $('[data-tc-sticky]'), sbName = sticky && $('[data-tc-sbname]', sticky), sbAdd = sticky && $('[data-tc-sbadd]', sticky);
    var curImg = 0;
    function curStyle() { return styles[cur]; }
    function imgs(s) {
      var a = [{ k: 'model', src: s.photo, alt: s.photoalt, cap: 'Exhibit ' + s.exhibit + ', No. ' + s.no + '.' }];
      if (s.print) a.push({ k: 'print', src: s.print, alt: s.printalt, cap: 'The print on its own.' });
      a.push({ k: 'sticker', src: s.sticker, alt: 'No. ' + s.no + ' ' + s.name + ', illustration of the print.', cap: 'Illustration of the print.' });
      return a;
    }
    function showImg(i) {
      var list = imgs(curStyle()); curImg = i; var m = list[i] || list[0];
      el.img.src = m.src; el.img.removeAttribute('srcset'); el.img.alt = m.alt;
      el.img.parentNode.setAttribute('data-kind', m.k);
      if (el.cap) el.cap.textContent = m.cap;
      $$('button', el.thumbs).forEach(function (b, k) { b.setAttribute('aria-pressed', k === i ? 'true' : 'false'); });
    }
    function renderThumbs() {
      var list = imgs(curStyle()); el.thumbs.innerHTML = '';
      list.forEach(function (p, i) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'tc-thumb';
        b.setAttribute('aria-label', 'Picture ' + (i + 1) + ' of ' + list.length + ': ' + p.cap); b.setAttribute('aria-pressed', 'false');
        b.innerHTML = '<img src="' + esc(p.src) + '" alt="" width="56" height="72" loading="lazy">';
        b.addEventListener('click', function () { showImg(i); });
        el.thumbs.appendChild(b);
      });
    }
    function currentVariant() { return findVariant(data.product, cur, size) || findVariant(data.product, cur, null); }
    function applyAvail() {
      var v = size ? findVariant(data.product, cur, size) : null;
      var any = data.product.variants.some(function (x) { return x.style === cur && x.available; });
      var off = size ? (!!v && !v.available) : !any;
      clearTimeout(el.add._t); el.add.removeAttribute('data-old'); el.add.disabled = off;
      el.addlbl.textContent = off ? 'Not available right now' : 'Add to bag'; if (el.pbuy) el.pbuy.disabled = off;
      if (sbAdd) { sbAdd.disabled = off; var sp = sbAdd.querySelector('span'); if (sp) sp.textContent = off ? 'Not available' : 'Buy now'; }
    }
    function syncVariant() { var v = currentVariant(); if (!v) return; el.id.value = v.id; el.price.textContent = v.price; applyAvail(); }
    function setStyle(no, opts) {
      if (!styles[no]) return; cur = no; var s = curStyle();
      el.no.textContent = 'No. ' + s.no; el.name.textContent = s.name; el.sub.textContent = s.summary; el.charge.textContent = s.charge;
      el.meter.innerHTML = meter(s.loud); el.loud.textContent = s.loud + ' of 5. ' + s.loudlabel;
      el.g.textContent = s.g; el.b.textContent = s.b; el.h.textContent = s.h; if (el.santa) el.santa.textContent = s.santa;
      var bk = $('[data-tc-book]', sec); if (bk) { bk.setAttribute('data-no', s.no); var bks = bk.querySelector('span'); (bks || bk).textContent = 'Try it on yourself'; }
      $$('.tc-chip', el.chips).forEach(function (c) { c.setAttribute('aria-pressed', +c.getAttribute('data-no') === no ? 'true' : 'false'); });
      if (sbName) sbName.textContent = 'No. ' + s.no + ', ' + s.name;
      renderThumbs(); showImg(0); syncVariant();
      document.title = 'No. ' + s.no + ' ' + s.name + ' ugly Christmas sweatshirt | Funny Christmas Jumpers';
      if (!(opts && opts.noUrl) && history.replaceState) { var v = currentVariant(); if (v) history.replaceState(null, '', location.pathname + '?variant=' + v.id); }
    }
    function doAdd(btn) {
      if (!size) { var pe = $('[data-tc-err]', sec); if (pe) pe.hidden = false; blink(el.sizes); if (el.live) { el.live.textContent = ''; setTimeout(function () { el.live.textContent = 'Pick a size first.'; }, 30); } el.sizes.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); return; }
      var v = findVariant(data.product, cur, size);
      if (!v) { setLabel(btn, 'Not offered in that size', 2000); return; }
      if (!v.available) { setLabel(btn, 'Not available right now', 3000); return; }
      if (btn.getAttribute('aria-disabled') === 'true') return;
      btn.setAttribute('aria-disabled', 'true'); setLabel(btn, 'Booking...', 4000);
      addToCart(v.id).then(function () {
        btn.removeAttribute('aria-disabled'); flash(); stampOn(el.stamp); setLabel(btn, 'In the bag', 1800);
        if (el.live) el.live.textContent = 'In the bag.'; if (el.checkout) el.checkout.hidden = false;
      }).catch(function (er) { btn.removeAttribute('aria-disabled'); setLabel(btn, failText(er), 3000); if (el.live) el.live.textContent = failText(er); });
    }
    el.chips.addEventListener('click', function (e) { var c = e.target.closest('.tc-chip'); if (c) setStyle(+c.getAttribute('data-no')); });
    el.sizes.addEventListener('click', function (e) {
      var z = e.target.closest('.tc-box'); if (!z) return;
      size = z.getAttribute('data-size');
      var pe2 = $('[data-tc-err]', sec); if (pe2) pe2.hidden = true;
      $$('.tc-box', el.sizes).forEach(function (c) { c.setAttribute('aria-pressed', c === z ? 'true' : 'false'); });
      el.sizehelp.textContent = 'Size ' + size + '. Between sizes? The size guide has the measurements.';
      var ex = $('[data-tc-express]', sec); if (ex) ex.hidden = false;
      syncVariant(); var v = findVariant(data.product, cur, size);
      if (v) { el.id.value = v.id; if (history.replaceState) history.replaceState(null, '', location.pathname + '?variant=' + v.id); }
    });
    if (el.form) el.form.addEventListener('submit', function (e) { e.preventDefault(); doAdd(el.add); });
    if (el.pbuy) el.pbuy.addEventListener('click', function () {
      if (!size) { doAdd(el.add); return; }
      var v = findVariant(data.product, cur, size);
      if (!v || !v.available) { setLabel(el.pbuy, 'Not available right now', 3000); return; }
      if (el.pbuy.getAttribute('aria-disabled') === 'true') return;
      el.pbuy.setAttribute('aria-disabled', 'true'); setLabel(el.pbuy, 'Booking...', 6000);
      addToCart(v.id).then(function () { location.assign(root + 'checkout'); })
        .catch(function (er) { el.pbuy.removeAttribute('aria-disabled'); setLabel(el.pbuy, failText(er), 3000); });
    });
    if (sbAdd) sbAdd.addEventListener('click', function () { if (el.pbuy) el.pbuy.click(); else doAdd(el.add); });
    sec.addEventListener('click', function (e) {
      var sb = e.target.closest('[data-tc-share]'); if (!sb) return;
      var who = $('[data-tc-for]', sec).value, v = currentVariant();
      share(shareText(who, curStyle()), location.origin + location.pathname + (v ? '?variant=' + v.id : ''), sb);
    });
    var buy = q('buy');
    if (sticky && buy && 'IntersectionObserver' in window) {
      var buyOut = false, footIn = false;
      var syncSticky = function () { var on = buyOut && !footIn; sticky.classList.toggle('is-on', on); sticky.setAttribute('aria-hidden', on ? 'false' : 'true'); if (sbAdd) sbAdd.tabIndex = on ? 0 : -1; };
      var io = new IntersectionObserver(function (es) { buyOut = !es[0].isIntersecting; syncSticky(); }, { threshold: 0 });
      io.observe(buy);
      var foot = $('.tc-foot');
      if (foot) { new IntersectionObserver(function (es) { footIn = es[0].isIntersecting; syncSticky(); }, { threshold: 0 }).observe(foot); }
    }
    setStyle(cur, { noUrl: true });
    refreshCart(true);
  }

  /* ---------- entry: one camera flash per session, content already painted underneath ---------- */
  function entry() {
    var stage = $('[data-tc-stage]'); if (!stage || reduce || inApp) return;
    var seen = false; try { seen = sessionStorage.getItem('tc-entered') === '1'; } catch (e) {}
    if (seen) return;
    var go = function () { flash(); try { sessionStorage.setItem('tc-entered', '1'); } catch (e) {} };
    var run = function () { requestAnimationFrame(function () { requestAnimationFrame(function () { setTimeout(go, 160); }); }); };
    if (!('IntersectionObserver' in window)) { run(); return; }
    var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { io.disconnect(); if (document.visibilityState === 'visible') run(); } }, { threshold: 0.35 });
    io.observe($('[data-tc-room]', stage) || stage);
  }

  /* ---------- leaving: sticker morphs into the product photo (arriving half is inline in layout/theme.liquid) ---------- */
  function transitions() {
    if (!('onpagereveal' in window)) return;
    var weak = Number(navigator.hardwareConcurrency) <= 2 || Number(navigator.deviceMemory) <= 2;
    var chosen = null;
    document.addEventListener('click', function (e) { var a = e.target.closest && e.target.closest('a[data-tc-vt-src]'); chosen = a && !e.defaultPrevented ? a : null; }, true);
    addEventListener('pageswap', function (e) {
      var vt = e.viewTransition; if (!vt) return;
      var to = e.activation && e.activation.entry && new URL(e.activation.entry.url, location.href);
      var img = chosen && document.querySelector('.tc-suspect-li[data-no="' + chosen.getAttribute('data-tc-vt-src') + '"] img');
      if (inApp || weak || reduce || !to || to.origin !== location.origin || to.pathname.indexOf('/products/') !== 0 || !img) { vt.skipTransition(); return; }
      img.style.viewTransitionName = 'tc-sticker';
      try { sessionStorage.setItem('tc-vt', String(Date.now())); } catch (x) {}
      ['pointerdown', 'keydown'].forEach(function (t) { document.addEventListener(t, function () { vt.skipTransition(); }, { once: true }); });
    });
  }

  /* Book yourself: loads tc-book.js/css on the first tap, then opens the full-screen panel */
  window.TC = { addToCart: addToCart, flash: flash, refreshCart: refreshCart, failText: failText };
  var bookLoading = null;
  function loadBook() {
    if (window.TCBook) return Promise.resolve();
    if (bookLoading) return bookLoading;
    var a = window.tcAssets || {};
    var css = new Promise(function (res) { var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = a.bookcss; l.onload = l.onerror = function () { res(); }; document.head.appendChild(l); });
    var js = new Promise(function (res, rej) { var s = document.createElement('script'); s.src = a.bookjs; s.onload = res; s.onerror = function () { bookLoading = null; rej(); }; document.head.appendChild(s); });
    bookLoading = Promise.all([css, js]);
    return bookLoading;
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-tc-book]'); if (!b) return;
    e.preventDefault(); var no = +b.getAttribute('data-no') || 1;
    loadBook().then(function () { window.TCBook.open(no); }).catch(function () {});
  });

  /* back/forward cache: drop a stale view-transition name so the sticker is not stuck mid-morph */
  addEventListener('pageshow', function (e) { if (e.persisted) $$('[style*="view-transition-name"]').forEach(function (i) { i.style.viewTransitionName = ''; }); });

  function boot(rootEl) {
    var r = rootEl || document;
    $$('[data-tc-stage]', r).forEach(function (s) { if (!s.hasAttribute('data-tc-ready')) { s.setAttribute('data-tc-ready', ''); initStage(s); } });
    $$('[data-tc-pdp]', r).forEach(function (s) { if (!s.hasAttribute('data-tc-ready')) { s.setAttribute('data-tc-ready', ''); initPdp(s); } });
    document.documentElement.classList.add('tc-ready');
  }
  bindExhibits(); transitions();
  function start() { boot(); entry(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
